"use client";

import { c as _c } from "react/compiler-runtime";
import type { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import { Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { collaboratorOptions, type ProposalFormValues } from "@/lib/proposal";
import { ProposalChoiceCard } from "./proposal-choice-card";
import { proposalChoiceGroupClassName, proposalFieldClassName } from "./proposal-form-constants";
type ProposalStepCompanyProps = {
  control: Control<ProposalFormValues>;
  errors: FieldErrors<ProposalFormValues>;
  register: UseFormRegister<ProposalFormValues>;
};
export function ProposalStepCompany(t0) {
  const $ = _c(16);
  const {
    control,
    errors,
    register
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Label className="sr-only" htmlFor="company">Nome da empresa</Label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== register) {
    t2 = register("company");
    $[1] = register;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Input {...t2} className={proposalFieldClassName} data-proposal-animate={true} id="company" placeholder="Nome da empresa" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== errors.company) {
    t4 = errors.company && <p className="-mt-1 text-sm text-red-300" data-proposal-animate={true}>{errors.company.message}</p>;
    $[5] = errors.company;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="space-y-6">{t1}{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label htmlFor="colaborators" className="font-bricolage text-[20px] leading-[1.4] font-normal" data-proposal-animate={true}>Total de colaboradores?</Label>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== control) {
    t7 = <div className="space-y-6" data-proposal-animate={true}>{t6}<Controller control={control} name="colaborators" render={_temp} /></div>;
    $[11] = control;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div className="space-y-12">{t5}{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp(t0) {
  const {
    field,
    fieldState
  } = t0;
  return <><div className={proposalChoiceGroupClassName}>{collaboratorOptions.map(option => <ProposalChoiceCard active={field.value?.includes(option) ?? false} key={option} onClick={() => field.onChange([option])}><span>{option}</span></ProposalChoiceCard>)}</div>{fieldState.error && <p className="text-sm text-red-300" data-proposal-animate={true}>{fieldState.error.message}</p>}</>;
}